'use client'
import React from 'react'

import type {IconProps} from './types'

import iconPaths from './constants'

const Icon = ({
  name,
  className,
  w = 24,
  h = 24,
  size = 24,
  viewBox = '0 0 24 24',
}: IconProps) => (
  <svg
    className={`h-${(size || h) / 4} w-${(size || w) / 4} ${className ? className : ''}`}
    viewBox={viewBox}>
    <path d={iconPaths[name]}></path>
  </svg>
)

export default Icon
